const formatPhoneNumber = (numberString) => {
  if (!numberString) return ''

  const digitsOnlyString = numberString.replace(/[^\d]/g, '')

  return digitsOnlyString.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
}

export default formatPhoneNumber
